// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#333","menuActiveText":"#409EFF","subMenuActiveText":"#333","menuBg":"#fff","menuHover":"#E8F4FF","subMenuBg":"#fff","subMenuHover":"#e6f7ff","sideBarWidth":"210px"};